module.exports = __webpack_public_path__ + "static/media/job-board-preview-2.3fe17870.png";